import React, { useState, useEffect } from 'react'

export default function Footer({ splatToggleFn, pathname }) {
    const [isOpen, setIsOpen] = useState(false);  

    const openSidebarClick = () => {
        setIsOpen(!isOpen);
        const sidebar = document.querySelector('.sidebar')
        const plusbutton = document.querySelector('.plusbutton')

        if (!isOpen) {
            sidebar.style.display = 'flex'; // Open sidebar
        } else {
            sidebar.style.display = 'none'; // Close sidebar
        }
    }; 

    const hideSidebarClick = () => {
        setIsOpen(false);
        const sidebar = document.querySelector('.sidebar')
        const plusbutton = document.querySelector('.plusbutton')
        sidebar.style.display = 'none'
    }; 
      
    const handleLinkClick = () => {
        setIsOpen(false); // Close the navigation when a link is clicked
        const sidebar = document.querySelector('.sidebar');
        sidebar.style.display = 'none'; // Ensure sidebar is hidden
    };

    // Handle window resize
    const handleResize = () => {
        if (window.innerWidth > 620) {  // When window width is larger than 650px
            setIsOpen(false); // Close sidebar if open
            const sidebar = document.querySelector('.sidebar');
            const plusbutton = document.querySelector('.plusbutton')
            sidebar.style.display = 'none'; // Hide the sidebar
        }
    };

    // Use useEffect to add and clean up the resize event listener
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
  return (
    <>
    <div className="footer">
        <footer>
            <ul>
                <li>
                    <a>
                        <img 
                            src="/ArmenianEternity.svg"
                            height="40px" 
                            width="40px"
                            viewBox="0 -960 960 960"  
                            fill="currentColor"
                        />
                    </a>
                </li>
            </ul>
            {splatToggleFn && (
                <button onClick={splatToggleFn} className="footer-switch-btn">
                    switch scene
                </button>
            )}
            {pathname === '/' && (
                <a href="/about" className="footer-about-link">
                    about
                </a>
            )}
        </footer>
    </div>
    </>
  )
}
